import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { DocumentTitle } from '@/components/DocumentTitle/DocumentTitle';
import type { IRouterContext } from '@/router';

export const Route = createRootRouteWithContext<IRouterContext>()({
  component: () => (
    <>
      <DocumentTitle />
      <Outlet />
      <TanStackRouterDevtools
        position="bottom-right"
        initialIsOpen={false}
      />
    </>
  ),
});
